<div class="nav-container">
  <p-toolbar class="top-bar">
    <div class="p-toolbar-group-left">
      <i class="pi pi-bars toggle-side-nav"
        (click)="displaySidebar = !displaySidebar">
      </i>
      <a [routerLink]="mpopDashboardUrl">
        <img src="https://mpop-prod-primary.s3.amazonaws.com/DT/dt_logoWhite.png"
          alt="Dealer Teamwork Logo"
          class="top-bar-logo"/>
      </a>
    </div>
    <img class="racing-stripes p-toolbar-group-right"
      src="https://mpop-prod-primary.s3.amazonaws.com/DT/dt-racing-stripes.png"
      alt="Dealer Teamwork racing stripes"/>
  </p-toolbar>

  @if (accountId) {
    <div class="top-menubar-wrapper">
      <p class="account-name-wrapper">
        {{accountName}}
      </p>
      @if (isLoaded) {
        <p-menubar class="top-nav"
          [model]="topNavItems"
          [autoDisplay]="false">
        </p-menubar>
      }
    </div>
  }
</div>

<p-drawer [(visible)]="displaySidebar"
  [modal]="false"
  [closable]="false"
  position="left">
  <p-panelMenu [model]="sideNavItems"
    [multiple]="false">
  </p-panelMenu>
</p-drawer>
